import {Countdown, type IDateTimer} from "data/utils/countdown";
import {DateTime} from "luxon";
import {IContest} from "data/stores/contests/contestsStore";
import {ChallengeRosterStatus} from "data/enums/challenge";
import {ContestStatus} from "data/enums";

export abstract class ContestsUtils {
	public static initLockTimer(contest: IContest): Countdown | undefined {
		const timeZone = "America/New_York";
		const contestDate = contest.date;

		const timeEST = DateTime.fromJSDate(new Date(contestDate), {
			zone: timeZone,
		});

		const timeESTJS = DateTime.fromJSDate(new Date(contestDate), {
			zone: timeZone,
		})
			// Hardcode the lock time of contests. It's required because we don't have actual lock time from BE
			.set({
				hour: timeEST.isWeekend ? 13 : 19,
			})
			.toJSDate();

		if (timeESTJS.getTime() < new Date().getTime()) {
			return;
		}

		return new Countdown(timeESTJS);
	}

	public static toTimeString(date?: IDateTimer | null) {
		if (!date) {
			return null;
		}
		const {days, minutes, hours, seconds} = date;

		if (!days) {
			return `${hours}h:${minutes}m:${seconds}s`;
		}
		return `${days}d:${hours}h:${minutes}m`;
	}

	public static toContestStatus(status: ChallengeRosterStatus) {
		return {
			[ChallengeRosterStatus.PLAYING]: ContestStatus.Live,
			[ChallengeRosterStatus.COMPLETE]: ContestStatus.Complete,
			[ChallengeRosterStatus.SCHEDULED]: ContestStatus.Open,
		}[status];
	}
}
